/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { WinstonInstrumentation } from './instrumentation';
export type { LogHookFunction, WinstonInstrumentationConfig } from './types';
